import { useContext } from "react";
import { Flex, Form, Button } from "antd";
import { IndexContext } from "../../context/IndexContext";
import useFetch from "../../hooks/useFetch";
import TextArea from "antd/es/input/TextArea";

const layout = {
  labelCol: {
    span: 24,
    padding: 0,
  },
  wrapperCol: {
    span: 24,
  },
};

export default function AcknowledgeAlarmForm(props) {
  const {
    selectedAlarmIDs,
    setIsAcknowledgementModalOpen,
    setSelectedAlarmIDs,
    selectedAlarmView,
    getSelectedDeviceActiveAlarm,
    getSelectedDeviceHistoricalAlarm,
  } = props;

  const [form] = Form.useForm();

  const { messageApi } = useContext(IndexContext);
  const [fetchWrapper] = useFetch();

  /* API to acknowledge alarm */
  function acknowledgeAlarm(user_inputs) {
    fetchWrapper({
      endpoint_url: "device_monitoring/acknowledgeAlarm",
      body: {
        alarm_ids: selectedAlarmIDs,
        acknowledge_mark: user_inputs.remark,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsAcknowledgementModalOpen(false);
          setSelectedAlarmIDs([]);
          if (selectedAlarmView === "Active") {
            getSelectedDeviceActiveAlarm();
          } else {
            getSelectedDeviceHistoricalAlarm();
          }
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
      },
    });
  }

  return (
    <Form
      form={form}
      {...layout}
      onFinish={(value) => {
        acknowledgeAlarm(value);
      }}
      clearOnDestroy
      autoComplete="off"
    >
      <Form.Item name={"remark"} label={"Remark"}>
        <TextArea autoSize={{ minRows: 5, maxRows: 10 }} allowClear />
      </Form.Item>

      <Flex justify="end" align="center" gap="middle">
        <Button
          type="default"
          onClick={() => setIsAcknowledgementModalOpen(false)}
        >
          Cancel
        </Button>
        <Button type="primary" htmlType="submit">
          Acknowledge
        </Button>
      </Flex>
    </Form>
  );
}
